// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0a93f7e3","732":"6a7e4576","977":"a2926f38"}[chunkId] + ".chunk.js";
};